<script setup>
import FeatureIcon1 from "@/assets/images/desktop/advantage/Group_3862.svg";
import FeatureIcon2 from "@/assets/images/desktop/advantage/Group_3863.svg";
import FeatureIcon3 from "@/assets/images/desktop/advantage/Group_3864.svg";
import FeatureIcon4 from "@/assets/images/desktop/advantage/Group_3865.svg";
import FeatureIcon5 from "@/assets/images/desktop/advantage/Group_3866.svg";

const features = [
  {
    title: "聊天機器人下單",
    desc: "免下載APP，手機一鍵搞定<br />隨時可下單",
    icon: FeatureIcon1,
  },
  {
    title: "專業 1688 代購經驗",
    desc: "台灣團隊，多年代購經驗<br />細心掌握每個流程",
    icon: FeatureIcon2,
  },
  {
    title: "費用明確清楚",
    desc: "收費結構透明<br />收到報價後，滿意再付款",
    icon: FeatureIcon3,
  },
  {
    title: "訂單進度一目了然",
    desc: "全程跟進訂單進度<br />服務時間內，即時溝通",
    icon: FeatureIcon4,
  },
  {
    title: "協助售後溝通",
    desc: "到貨後如有問題<br />協助您與 1688 廠商溝通",
    icon: FeatureIcon5,
  },
];
</script>

<template>
  <section class="features-section">
    <div class="features-header">
      <div style="display: flex; padding-top: 90px; justify-content: center">
        <picture>
          <source
            media="(min-width: 1060px)"
            srcset="@/assets/images/desktop/advantage/right.svg"
          />
          <img src="@/assets/images/mobile/advantage/right.svg" alt="" />
        </picture>
        <p class="feature-content">
          CHATxBUY <span style="color: #3c5bff">5</span> 大特色
        </p>
        <picture>
          <source
            media="(min-width: 1060px)"
            srcset="@/assets/images/desktop/advantage/left.svg"
          />
          <img src="@/assets/images/mobile/advantage/left.svg" alt="" />
        </picture>
      </div>
      <div class="sidehead">
        化繁為簡，為您提供 1688<br />
        專業一條龍代買服務
      </div>
    </div>

    <div class="features-list">
      <div v-for="(feature, index) in features" :key="index" class="step-5-box">
        <img :src="feature.icon" :alt="feature.title" />
        <div class="feature-text-group">
          <p class="p-content">{{ feature.title }}</p>
          <p class="p-content2" v-html="feature.desc"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Features Section */
.feature-content {
  font-weight: 800;
  font-size: 26px;
  transform: scaleY(1.05);
  color: #343a40;
  margin: 0;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 10px;
}

.sidehead {
  font-weight: 500;
  font-size: 18px;
  color: #495057;
  padding-top: 24px;
  text-align: center;
}

.features-list {
  padding-top: 60px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.step-5-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.feature-text-group {
  display: flex;
  flex-direction: column;
}

.p-content {
  color: #5974ff;
  font-weight: bold;
  font-size: 20px;
  padding-top: 20px;
  padding-bottom: 13px;
  margin: 0;
  text-align: center;
}

.p-content2 {
  color: #495057;
  font-size: 15px;
  text-align: center;
}

@media (min-width: 1060px) {
  .feature-content {
    font-size: 38px;
    padding-left: 22px;
    padding-right: 22px;
  }

  .sidehead {
    font-size: 24px;
    padding-top: 30px;
  }

  .features-list {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
  }
}
</style>
